<script>
import formStepMixin from '@phoenix/mixins/formStepMixin';
import FormGroup from '@maison/components/form/FormGroup.vue';
import TextField from '@maison/components/form/fields/TextField.vue';
import PhoneField from '@maison/components/form/fields/PhoneField';
import SelectField from '@maison/components/form/fields/SelectField';

export default {
  components: {
    PhoneField,
    FormGroup,
    TextField,
    SelectField,
  },

  mixins: [formStepMixin],
};
</script>

<template>
  <div>
    <legend class="sr-only">{{ $t(`Form.gep.step1.label`) }}</legend>

    <section class="mb-10">
      <h5 class="mb-4">{{ $t(`Form.gep.step1.title`) }}</h5>
      <p>{{ $t(`Form.gep.step1.description`) }}</p>
    </section>

    <div class="flex-grid flex-grid--x--md flex-grid--y--md">
      <div class="w-full md:w-1/2">
        <form-group :attrs="fields.country">
          <select-field v-model="fields.country.value" />
        </form-group>
      </div>

      <div v-if="fieldIsPresent('title')" class="w-full md:w-1/2">
        <form-group :attrs="fields.title">
          <select-field v-model="fields.title.value" />
        </form-group>
      </div>

      <div v-if="fieldIsPresent('gender')" class="w-full md:w-1/2">
        <form-group :attrs="fields.gender">
          <select-field v-model="fields.gender.value" />
        </form-group>
      </div>

      <div v-if="fieldIsPresent('firstName1')" class="w-full md:w-1/2">
        <form-group :attrs="fields.firstName1">
          <text-field v-model="fields.firstName1.value" />
        </form-group>
      </div>

      <div v-if="fieldIsPresent('lastName1')" class="w-full md:w-1/2">
        <form-group :attrs="fields.lastName1">
          <text-field v-model="fields.lastName1.value" />
        </form-group>
      </div>

      <div v-if="fieldIsPresent('firstName2')" class="w-full md:w-1/2">
        <form-group :attrs="fields.firstName2">
          <text-field v-model="fields.firstName2.value" />
        </form-group>
      </div>

      <div v-if="fieldIsPresent('lastName2')" class="w-full md:w-1/2">
        <form-group :attrs="fields.lastName2">
          <text-field v-model="fields.lastName2.value" />
        </form-group>
      </div>

      <div class="w-full md:w-1/2">
        <form-group :attrs="fields.phone">
          <phone-field v-model="fields.phone.value" />
        </form-group>
      </div>

      <div class="w-full md:w-1/2">
        <form-group :attrs="fields.email">
          <text-field v-model="fields.email.value" />
        </form-group>
      </div>

      <div class="w-full md:w-1/2">
        <form-group :attrs="fields.language">
          <select-field v-model="fields.language.value" />
        </form-group>
      </div>

      <div class="w-full md:w-1/2">
        <form-group :attrs="fields.interests">
          <select-field v-model="fields.interests.value" />
        </form-group>
      </div>
    </div>
  </div>
</template>
